import React, { useEffect } from 'react';
import { Command } from 'cmdk';
import { useNavigate } from 'react-router-dom';
import { HugeiconsIcon } from '@hugeicons/react';
import { Search01Icon, ArrowRight01Icon } from '@hugeicons/core-free-icons';

const CommandPalette = ({ isOpen, setIsOpen, transactions }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const down = (e) => {
      if (e.key === 'k' && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        setIsOpen((open) => !open);
      }
    };

    document.addEventListener('keydown', down);
    return () => document.removeEventListener('keydown', down);
  }, [setIsOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-start justify-center pt-[20vh] px-4">
      <div 
        className="fixed inset-0 bg-black/40 backdrop-blur-sm" 
        onClick={() => setIsOpen(false)}
      />
      
      <Command className="relative w-full max-w-lg bg-white dark:bg-dark-surface rounded-xl shadow-2xl border border-light-gray dark:border-dark-border overflow-hidden">
        <div className="flex items-center border-b border-light-gray dark:border-dark-border px-4">
          <HugeiconsIcon icon={Search01Icon} className="text-muted-gray w-5 h-5 mr-2" />
          <Command.Input 
            className="w-full h-14 bg-transparent outline-none text-charcoal dark:text-white placeholder-muted-gray" 
            placeholder="Search transactions, agents, or status..." 
          />
        </div>

        <Command.List className="max-h-[300px] overflow-y-auto p-2 scroll-py-2">
          <Command.Empty className="p-4 text-center text-sm text-muted-gray">No results found.</Command.Empty>

          <Command.Group heading="Transactions" className="text-xs font-semibold text-muted-gray px-2 py-2 mb-2">
            {transactions.map((tx) => (
              <Command.Item
                key={tx.link_token || tx.id}
                onSelect={() => {
                  setIsOpen(false);
                  navigate(`/transaction/${tx.id}`);
                }}
                className="flex items-center justify-between px-3 py-3 rounded-lg text-sm text-charcoal dark:text-gray-200 cursor-pointer hover:bg-off-white dark:hover:bg-gray-800 aria-selected:bg-off-white dark:aria-selected:bg-gray-800 transition-colors"
              >
                <div className="flex flex-col">
                  <span className="font-medium">{tx.merchant?.name || tx.agent?.email || 'User'}</span>
                  <span className="text-xs text-muted-gray">
                    {tx.link_token || tx.id} • {new Date(tx.created_at).toLocaleDateString()}
                  </span>
                </div>
                <div className="flex items-center gap-3">
                  <span className={`text-xs font-bold uppercase ${
                    tx.transaction_type === 'deposit' ? 'text-blue-600' : 'text-purple-600'
                  }`}>{tx.transaction_type}</span>
                  <span className="font-mono font-medium">
                    {tx.currency === 'NGN' ? '₦' : '$'}{parseFloat(tx.total_amount_usd || tx.amount_sent || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </span>
                  <HugeiconsIcon icon={ArrowRight01Icon} size={14} className="text-gray-400" />
                </div>
              </Command.Item>
            ))}
          </Command.Group>
        </Command.List>
        
        <div className="border-t border-light-gray dark:border-dark-border px-4 py-2 text-[10px] text-muted-gray flex justify-between">
          <span>Search for anything...</span>
          <div className="flex gap-2">
             <span>Open</span> <kbd className="font-sans bg-gray-100 dark:bg-gray-800 px-1 rounded">↵</kbd>
          </div>
        </div>
      </Command>
    </div>
  );
};

export default CommandPalette;
